const d = {
    'app.login.log-in': 'Login',
}

export default d;